import { startSearch } from '../actions/startSearch';
import getScenarioStore from '../selectors/getScenarioStore';
import { ActionSource } from 'owa-analytics-actions';
import { mutator } from 'satcheljs';

export default mutator(startSearch, actionMessage => {
    const { scenarioId, actionSource } = actionMessage;
    const store = getScenarioStore(scenarioId);

    // Set source of search
    store.queryActionSource = actionSource as ActionSource;

    // Clear query alteration type from previous search
    store.queryAlterationType = null;
});
